import type {Variants} from 'framer-motion'

export const PulseVariants: Variants = {
  invisible: {scale: 0, opacity: 0},
  fade: {
    opacity: [1, 0],
    transition: {duration: 0.3, ease: 'easeInOut'},
  },
  blend: {
    opacity: [0, 1],
    transition: {duration: 0.3, ease: 'easeInOut'},
  },
  pulse: {
    scale: [1, 0.98, 1.02, 1],
    opacity: 1,
    transition: {duration: 1, repeat: 2, repeatType: 'reverse', ease: 'easeInOut'},
  },
  visible: {
    scale: 1,
    opacity: 1,
  },
}
